var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_html.js
// module id = +iDZ
// module chunks = 15